import { FC } from 'react';
import { TablePaginationProps } from './types';
import { Flex, Pagination } from '@mantine/core';

export const TablePagination: FC<TablePaginationProps> = ({
  pageNumber,
  totalNumberOfPages,
  setPageNumber,
}) => {
  return (
    <Flex w="100%" gap="md" justify="flex-end">
      <Pagination
        getControlProps={() => {
          return {
            'aria-label': 'pagination-button',
            id: 'pagination-button',
          };
        }}
        value={pageNumber}
        color="orange"
        total={totalNumberOfPages}
        defaultValue={0}
        onChange={setPageNumber}
      />
    </Flex>
  );
};
